import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';
import CardBlockDataForm from './Data';
import CardBlockView from './View';
import type { CardBlockData } from './index';

interface CardBlockEditProps {
  data: CardBlockData;
  onChangeBlock: (id: string, data: CardBlockData) => void;
  block: string;
  selected: boolean;
  [key: string]: any;
}

const CardBlockEdit: React.FC<CardBlockEditProps> = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <CardBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <CardBlockDataForm
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(CardBlockEdit);
